import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {TranslateModule} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {TerceroUpPasarelaContratoService} from '../../../../../_services/tercero-up-pasarela-contrato.service';
import {TerceroUPPasarelaContrato} from '../../../../../_models/tercero-up-pasarela-contrato';
import {PlantillaService} from '../../../../../_services/plantilla.service';
import {PlantillaVersionService} from '../../../../../_services/plantilla-version.service';
import {filtrarPorTexto} from '../../admsb-titular.helpers';

@Component({
  selector: 'app-admsb-contratos-tabla',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
  ],
  templateUrl: './admsb-contratos-tabla.component.html',
  styleUrls: ['./admsb-contratos-tabla.component.scss'],
})
export class AdmsbContratosTablaComponent implements OnInit {

  /** Identificador de la pasarela del titular (idTerceroUPPasarela) */
  @Input() idTitular: string;

  /** Modo de visualización: 'tabla' (Administrador de servicios) o 'matrix' (Gestión Centralizada Matrix) */
  @Input() vista: 'tabla' | 'matrix' = 'tabla';

  /** Evento emitido al solicitar previsualizar un contrato en modo matrix */
  @Output() previsualizar = new EventEmitter<TerceroUPPasarelaContrato>();

  contratos: TerceroUPPasarelaContrato[] = [];
  cargandoContratos = true;

  /** Texto del buscador de la tabla de contratos */
  filtroContratos = '';

  /** Controla la visibilidad del modal de previsualización de contrato (vista tabla) */
  mostrarModalContrato = false;

  /** Contrato actualmente seleccionado para previsualización */
  contratoSeleccionado: TerceroUPPasarelaContrato | null = null;

  /** Cuerpo HTML sanitizado de la plantilla asociada al contrato previsualizado */
  contenidoContrato: SafeHtml | null = null;

  constructor(
    private terceroUpPasarelaContratoServicio: TerceroUpPasarelaContratoService,
    private plantillaServicio: PlantillaService,
    private plantillaVersionServicio: PlantillaVersionService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    if (this.idTitular) {
      this.cargarContratos(this.idTitular);
    } else {
      this.cargandoContratos = false;
    }
  }

  private cargarContratos(idTerceroUPPasarela: string): void {
    this.terceroUpPasarelaContratoServicio.listPasarelasContratos(idTerceroUPPasarela).subscribe({
      next: res => {
        this.contratos = res;
        this.cargandoContratos = false;
      },
      error: () => this.cargandoContratos = false,
    });
  }

  /**
   * Contratos filtrados localmente por nombre de plantilla, nombre de servicio, descripción o fecha de la firma según el texto del buscador.
   */
  get contratosFiltrados(): TerceroUPPasarelaContrato[] {
    return filtrarPorTexto(this.contratos, this.filtroContratos, [
      c => c.nombreContratosServicios,
      c => c.nombrePlantilla,
      c => c.descripcion,
      c => c.fechaFirma
    ]);
  }

  /**
   * Consulta el cuerpo de la plantilla asociada al contrato (por versión si existe, si no por la plantilla base)
   * y lo muestra en el modal de previsualización (modo tabla) o emite el evento para el visor lateral (modo matrix).
   */
  previsualizarContrato(contrato: TerceroUPPasarelaContrato): void {
    if (this.vista === 'matrix') {
      this.previsualizar.emit(contrato);
      return;
    }

    this.contenidoContrato = null;
    this.mostrarModalContrato = true;

    if (contrato.idPlantillaVersion) {
      this.plantillaVersionServicio.obtenerPorId(contrato.idPlantillaVersion).subscribe(res =>
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo));
    } else if (contrato.idPlantilla) {
      this.plantillaServicio.getById(contrato.idPlantilla).subscribe(res =>
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo));
    }
  }

  cerrarModalContrato(): void {
    this.mostrarModalContrato = false;
  }

}
